// Wrapper for pickadate

const months = [
	['Jan', 'January', 'Ene', 'Enero', 'Janv', 'Janvier'],
	['Feb', 'February', 'Febrero', 'Févr', 'Février'],
	['Mar', 'March', 'Marzo', 'Mars'],
	['Apr', 'April', 'Abr', 'Abril', 'Avril'],
	['May', 'Mayo', 'Mai'],
	['Jun', 'June', 'Junio', 'Juin'],
	['Jul', 'July', 'Julio', 'Juil', 'Juillet'],
	['Aug', 'August', 'Ago', 'Agosto', 'Août'],
	['Sep', 'Sept', 'September', 'Septiembre', 'Septembre'],
	['Oct', 'October', 'Octubre', 'Octobre'],
	['Nov', 'November', 'Noviembre', 'Novembre'],
	['Dec', 'December', 'Dic', 'Diciembre', 'Déc', 'Décembre'],
];

const translateDate = (date) => {
	let newDate;
	months.forEach((row) => {
		row.forEach((month) => {
			if (date.toLowerCase().indexOf(month.toLowerCase()) > -1) {
				newDate = date.toLowerCase().replace(month.toLowerCase(), row[0]);
			}
			if (newDate) {
				return newDate;
			}
		});
		if (newDate) {
			return newDate;
		}
	});
	return newDate || date;
};


class DatePicker {
	constructor(el, customConfig = null) {
		this.el = $(el || '<input></input>');

		this.format = 'yyyy mmm dd';
		if (window.DATE_FORMAT === '0') {
			this.format = 'mmm dd yyyy';
		} else if (window.DATE_FORMAT === '1') {
			this.format = 'dd mmm yyyy';
		} else if (window.DATE_FORMAT === '2') {
			this.format = 'yyyy mmm dd';
		}

		if (el.val instanceof Function && this.el.val()) {
			// http://amsul.ca/pickadate.js/date/#formats_prefill
			let dateVal = this.el.val();
			if (!Date.parse(dateVal)) {
				dateVal = translateDate(dateVal);
			}
			const jsDate = new Date(dateVal);
			let day = jsDate.getDate();
			let month = jsDate.getMonth() + 1;
			let year = jsDate.getFullYear();
			// Trick for fixing dates that are behind UTC, and therefore have date one day in the past
			// when showing with UTC offset. Getting UTCDate and UTCMonth makes the date have the original date again
			if (jsDate.getTimezoneOffset() > 0) {
				day = jsDate.getUTCDate();
				month = jsDate.getUTCMonth() + 1;
				year = jsDate.getUTCFullYear();
			}
			const formattedDate = `${month <= 9 ? `0${month}` : month}`
				+ `/${day <= 9 ? `0${day}` : day}`
				+ `/${year}`;
			this.el.data('value', formattedDate);
		}

		const config = {
			selectYears: 200,
			selectMonths: true,
			format: this.format,
			formatSubmit: 'mm/dd/yyyy',
			hiddenName: true,
			klass: {
				selectMonth: 'picker__select--month',
				selectYear: 'picker__select--year',
			},
		};

		if (customConfig !== null) {
			_.extend(config, customConfig);
		}

		this.picker = this.el
			.pickadate(config)
			.pickadate('picker');
	}

	get() {
		return this.picker.get('select', 'yyyy/mm/dd');
	}

	set(thing, value) {
		return this.picker.set(thing, value);
	}
}

module.exports = DatePicker;
